<template>
    <div>
        <dx-grid
            :url="url"
            :columns="columns"
            :title="title"
            :actions="actions"
            :beforeSetupGrid="beforeSetupGrid"
            :onRowClicked="onRowClicked"
            navigationPath="onRowClicked"
            navigationField="onRowClicked"
            ref="grid"
        ></dx-grid>

        <!-- ── Details dialog ── -->
        <v-dialog v-model="detailsDialog" max-width="920" persistent scrollable>
            <v-card class="tcs-dialog">
                <!-- Header -->
                <div class="tcs-header">
                    <div class="tcs-header-left">
                        <div class="tcs-header-name">
                            {{ clickedApplication.hname || "Application" }}
                        </div>
                        <div class="tcs-header-ref">
                            Account:
                            {{ trim(clickedApplication.accountID) || "-" }}
                            &nbsp;|&nbsp; Term:
                            {{ trim(clickedApplication.formRegID) || "-" }}
                            &nbsp;|&nbsp; Submitted:
                            {{ formatDateTime(clickedApplication.date) }}
                        </div>
                    </div>
                </div>

                <div class="tcs-body">
                    <v-layout row wrap class="tcs-sections">
                        <!-- Left column: family -->
                        <v-flex xs12 sm6 class="tcs-col pr-3">
                            <div class="tcs-section">
                                <div class="tcs-section-title">Family Info</div>
                                <div class="tcs-row">
                                    <span class="tcs-label">Account ID</span>
                                    <span class="tcs-val">{{
                                        trim(clickedApplication.accountID) ||
                                            "-"
                                    }}</span>
                                </div>
                                <div class="tcs-row">
                                    <span class="tcs-label">Hebrew Name</span>
                                    <span class="tcs-val">{{
                                        clickedApplication.hname || "-"
                                    }}</span>
                                </div>
                                <div class="tcs-row">
                                    <span class="tcs-label">Mother Name</span>
                                    <span class="tcs-val">{{
                                        clickedApplication.c12gmname || "-"
                                    }}</span>
                                </div>
                                <div class="tcs-row">
                                    <span class="tcs-label">Home Phone</span>
                                    <span class="tcs-val">{{
                                        clickedApplication.hphone || "-"
                                    }}</span>
                                </div>
                                <div class="tcs-row">
                                    <span class="tcs-label">Address</span>
                                    <span class="tcs-val">{{
                                        clickedApplication.address1 || "-"
                                    }}</span>
                                </div>
                            </div>
                        </v-flex>

                        <!-- Right column: eligibility -->
                        <v-flex xs12 sm6 class="tcs-col">
                            <div class="tcs-section">
                                <div class="tcs-section-title">
                                    Eligibility
                                </div>
                                <div class="tcs-row">
                                    <span class="tcs-label"
                                        >Scholarship Situation</span
                                    >
                                    <span class="tcs-val">{{
                                        clickedApplication.scholarshipSituationLabel ||
                                            "-"
                                    }}</span>
                                </div>
                                <!-- <div class="tcs-row">
                                    <span class="tcs-label"
                                        >Situation Label</span
                                    >
                                    <span class="tcs-val">{{
                                        clickedApplication.scholarshipSituationLabel ||
                                            "-"
                                    }}</span>
                                </div> -->
                                <div class="tcs-row">
                                    <span class="tcs-label"
                                        >Household Size</span
                                    >
                                    <span class="tcs-val">{{
                                        formatNumber(
                                            clickedApplication.householdSize,
                                        )
                                    }}</span>
                                </div>
                                <div class="tcs-row">
                                    <span class="tcs-label"
                                        >Eligible For SNAP / Medicaid</span
                                    >
                                    <span class="tcs-val">
                                        <v-icon
                                            small
                                            :color="
                                                boolColor(
                                                    clickedApplication.eligebleForSnapOrMedicaid,
                                                )
                                            "
                                            class="mr-1"
                                            >{{
                                                boolIcon(
                                                    clickedApplication.eligebleForSnapOrMedicaid,
                                                )
                                            }}</v-icon
                                        >
                                        {{
                                            formatBool(
                                                clickedApplication.eligebleForSnapOrMedicaid,
                                            )
                                        }}
                                    </span>
                                </div>
                                <div class="tcs-row">
                                    <span class="tcs-label"
                                        >Income Under Threshold</span
                                    >
                                    <span class="tcs-val">{{
                                        clickedApplication.schoolChoiceHouseholdIncomeUnderThreshold ||
                                            "-"
                                    }}</span>
                                </div>
                            </div>
                        </v-flex>

                        <!-- Father -->
                        <v-flex xs12 sm6 class="tcs-col pr-3">
                            <div class="tcs-section">
                                <div class="tcs-section-title">Father</div>
                                <div class="tcs-row">
                                    <span class="tcs-label">Employer</span>
                                    <span class="tcs-val">{{
                                        clickedApplication.schoolChoiceFatherEmployer ||
                                            "-"
                                    }}</span>
                                </div>
                                <div class="tcs-row">
                                    <span class="tcs-label">Occupation</span>
                                    <span class="tcs-val">{{
                                        clickedApplication.schoolChoiceFatherOccupation ||
                                            "-"
                                    }}</span>
                                </div>
                                <div class="tcs-row">
                                    <span class="tcs-label"
                                        >Business Owner</span
                                    >
                                    <span class="tcs-val">
                                        <v-icon
                                            small
                                            :color="
                                                boolColor(
                                                    clickedApplication.schoolChoiceFatherBusinessOwner,
                                                )
                                            "
                                            class="mr-1"
                                            >{{
                                                boolIcon(
                                                    clickedApplication.schoolChoiceFatherBusinessOwner,
                                                )
                                            }}</v-icon
                                        >
                                        {{
                                            formatBool(
                                                clickedApplication.schoolChoiceFatherBusinessOwner,
                                            )
                                        }}
                                    </span>
                                </div>
                            </div>
                        </v-flex>

                        <!-- Mother -->
                        <v-flex xs12 sm6 class="tcs-col">
                            <div class="tcs-section">
                                <div class="tcs-section-title">Mother</div>
                                <div class="tcs-row">
                                    <span class="tcs-label">Employer</span>
                                    <span class="tcs-val">{{
                                        clickedApplication.schoolChoiceMotherEmployer ||
                                            "-"
                                    }}</span>
                                </div>
                                <div class="tcs-row">
                                    <span class="tcs-label">Occupation</span>
                                    <span class="tcs-val">{{
                                        clickedApplication.schoolChoiceMotherOccupation ||
                                            "-"
                                    }}</span>
                                </div>
                                <div class="tcs-row">
                                    <span class="tcs-label"
                                        >Business Owner</span
                                    >
                                    <span class="tcs-val">
                                        <v-icon
                                            small
                                            :color="
                                                boolColor(
                                                    clickedApplication.schoolChoiceMotherBusinessOwner,
                                                )
                                            "
                                            class="mr-1"
                                            >{{
                                                boolIcon(
                                                    clickedApplication.schoolChoiceMotherBusinessOwner,
                                                )
                                            }}</v-icon
                                        >
                                        {{
                                            formatBool(
                                                clickedApplication.schoolChoiceMotherBusinessOwner,
                                            )
                                        }}
                                    </span>
                                </div>
                            </div>
                        </v-flex>
                    </v-layout>

                    <!-- Note -->
                    <div class="tcs-section">
                        <div class="tcs-section-title">Scholarship Note</div>
                        <div v-if="!scholarshipNoteText" class="tcs-note-empty">
                            <v-icon small>mdi-information-outline</v-icon>
                            <span>No note on this application.</span>
                        </div>
                        <div v-else class="tcs-note-card">
                            <div class="tcs-note-avatar">
                                <v-icon>mdi-note-text-outline</v-icon>
                            </div>
                            <div class="tcs-note-body">
                                <div
                                    class="tcs-note-meta"
                                    v-if="clickedApplication.date"
                                >
                                    {{
                                        formatNoteDate(clickedApplication.date)
                                    }}
                                </div>
                                <div class="tcs-note-text">
                                    {{ scholarshipNoteText }}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- Footer -->
                <div class="tcs-footer">
                    <v-spacer></v-spacer>
                    <v-btn color="default" dark @click="closeDetailsDialog"
                        >Close</v-btn
                    >
                </div>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import moment from "moment";

export default {
    data: () => ({
        title: "Tuition Scholarship Applications",

        url: "",
        regID: "",

        actions: [],

        detailsDialog: false,
        clickedApplication: {},

        columns: [
            {
                label: "Account ID",
                field: "accountID",
                link: "Account View",
                format: "",
                template: "link-cell-template",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Hebrew Name",
                field: "hname",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Address",
                field: "address1",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Home Phone",
                field: "hphone",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Date",
                field: "date",
                type: "date",
                format: "MM/dd/yyyy hh:mm:ss a",
                visible: true,
                sortOrder: "desc",
                sortIndex: 0,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Scholarship Situation",
                field: "scholarshipSituationLabel",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            // {
            //     label: "Scholarship Situation Label",
            //     field: "scholarshipSituationLabel",
            //     visible: true,
            //     filterValues: [],
            //     filterValue: null,
            //     selectedFilterOperation: null,
            // },
            {
                label: "Scholarship Note",
                field: "scholarshipNote",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Household Size",
                field: "householdSize",
                type: "number",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Eligible For SNAP / Medicaid",
                field: "eligebleForSnapOrMedicaid",
                type: "boolean",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Income Under Threshold",
                field: "schoolChoiceHouseholdIncomeUnderThreshold",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Father Employer",
                field: "schoolChoiceFatherEmployer",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Father Occupation",
                field: "schoolChoiceFatherOccupation",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Father Business Owner",
                field: "schoolChoiceFatherBusinessOwner",
                type: "boolean",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Mother Employer",
                field: "schoolChoiceMotherEmployer",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Mother Occupation",
                field: "schoolChoiceMotherOccupation",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Mother Business Owner",
                field: "schoolChoiceMotherBusinessOwner",
                type: "boolean",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Reg ID",
                field: "formRegID",
                visible: false,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
        ],
    }),
    computed: {
        scholarshipNoteText() {
            const note = this.clickedApplication.scholarshipNote;

            return note ? note.trim() : "";
        },
    },
    methods: {
        async beforeSetupGrid() {
            await this.loadRegID();

            const terms = await this.getTerms();

            this.actions.push({
                text: "Select Term",
                type: "select",
                values: terms,
                align: "left",
                value: this.regID,
                onSelected: this.onTermSelected,
            });

            this.url = this.buildUrl();
        },
        async loadRegID() {
            this.regID = await this.$http.get(
                "api/tuitionContractScholarshipApplications/getCurrentRegID",
            );
        },
        async getTerms() {
            return await this.$http.get(
                "api/tuitionContractScholarshipApplications/getRegIDs",
            );
        },
        onTermSelected(value) {
            this.regID = value;

            this.url = this.buildUrl();

            this.$refs.grid.reloadDataSource(this.url);
        },
        buildUrl() {
            return "tuitionContractScholarshipApplications?regID=" + this.regID;
        },
        onRowClicked(row) {
            this.clickedApplication = Object.assign({}, row);

            this.detailsDialog = true;
        },
        closeDetailsDialog() {
            this.detailsDialog = false;
            this.clickedApplication = {};
        },
        trim(value) {
            return value ? value.trim() : "";
        },
        formatDateTime(value) {
            if (!value) return "-";

            return moment(value).format("MM/DD/YYYY hh:mm:ss a");
        },
        formatNoteDate(value) {
            if (!value) return "";

            return moment(value).format("MMM D, YYYY, h:mm A");
        },
        formatNumber(value) {
            if (value === null || value === undefined || value === "")
                return "-";

            return value;
        },
        formatBool(value) {
            if (value === true) return "Yes";
            if (value === false) return "No";

            return "-";
        },
        boolIcon(value) {
            if (value === true) return "mdi-check-circle";
            if (value === false) return "mdi-close-circle";

            return "mdi-help-circle-outline";
        },
        boolColor(value) {
            if (value === true) return "#2e7d32";
            if (value === false) return "#9e9e9e";

            return "#bdbdbd";
        },
    },
};
</script>

<style>
/* ── Dialog shell ── */
.tcs-dialog {
    background: #fff;
    border-radius: 10px;
    display: flex !important;
    flex-direction: column;
    max-height: 92vh;
    overflow: hidden;
}

/* ── Header ── */
.tcs-header {
    display: flex;
    flex-shrink: 0;
    align-items: flex-start;
    justify-content: space-between;
    background: #4caf50;
    color: #fff;
    padding: 20px 24px 16px;
}
.tcs-header-name {
    font-size: 18px;
    font-weight: 600;
}
.tcs-header-ref {
    font-size: 12px;
    opacity: 0.8;
    margin-top: 6px;
}
/* ── Body ── */
.tcs-body {
    padding: 20px 24px 0;
    flex: 1;
    overflow-y: auto;
    min-height: 0;
}
.tcs-sections {
    margin-bottom: 4px;
}
.tcs-col {
    padding-bottom: 4px;
}

/* ── Section ── */
.tcs-section {
    margin-bottom: 18px;
}
.tcs-section-title {
    font-size: 11px;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0.8px;
    color: #2e7d32;
    border-bottom: 2px solid #e8f5e9;
    padding-bottom: 4px;
    margin-bottom: 8px;
}

/* ── Label / value row ── */
.tcs-row {
    display: flex;
    align-items: flex-start;
    padding: 5px 0;
    border-bottom: 1px solid #f5f5f5;
    font-size: 13.5px;
    line-height: 1.4;
}
.tcs-row:last-child {
    border-bottom: none;
}
.tcs-label {
    flex: 0 0 168px;
    color: #757575;
    padding-right: 10px;
}
.tcs-val {
    flex: 1;
    color: #212121;
    font-weight: 500;
    word-break: break-word;
}

/* ── Note ── */
.tcs-note-empty {
    display: flex;
    align-items: center;
    background: #eef6fd;
    border: 1px solid #d3e7f7;
    border-radius: 8px;
    padding: 12px 14px;
    font-size: 13px;
    color: #607d94;
}
.tcs-note-empty .v-icon {
    flex-shrink: 0;
    color: #64a3d8;
    margin-right: 8px;
}
.tcs-note-card {
    display: flex;
    align-items: flex-start;
    background: #f3fbf4;
    border: 1px solid #dcedc8;
    border-radius: 8px;
    padding: 14px;
}
.tcs-note-avatar {
    flex: 0 0 36px;
    width: 36px;
    height: 36px;
    border-radius: 50%;
    background: #4caf50;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-right: 12px;
}
.tcs-note-avatar .v-icon {
    color: #fff;
    font-size: 18px;
}
.tcs-note-body {
    flex: 1;
    min-width: 0;
}
.tcs-note-meta {
    font-size: 11.5px;
    color: #757575;
    margin-bottom: 4px;
}
.tcs-note-text {
    font-size: 13.5px;
    line-height: 1.5;
    color: #212121;
    white-space: pre-wrap;
    word-break: break-word;
}

/* ── Footer ── */
.tcs-footer {
    display: flex;
    flex-shrink: 0;
    justify-content: flex-end;
    align-items: center;
    padding: 14px 24px 16px;
    border-top: 1px solid #f0f0f0;
    background: #fff;
}
</style>
